import * as preact from "preact";

type DialogProps = {
  actions?: preact.ComponentChild;
  children?: preact.ComponentChildren;
  class?: string;
  error?: string | null;
  heading?: preact.ComponentChildren;
  headingIcon?: string;
  onClick?: preact.JSX.MouseEventHandler<HTMLDivElement>;
  success?: preact.ComponentChild;
};

export default function Dialog(props: DialogProps) {
  const cls = ["dialog", props.class].filter(Boolean).join(" ");
  if (props.success) {
    return (
      <div class={cls} onClick={props.onClick}>
        <div class="dialogSuccess">{props.success}</div>
      </div>
    );
  }
  return (
    <div class={cls} onClick={props.onClick}>
      {props.heading && (
        <h2 class="dialogHeading">
          {props.headingIcon && <i class={`icon-${props.headingIcon}`}></i>}
          {props.headingIcon && " "}
          {props.heading}
        </h2>
      )}
      {props.children}
      {props.error && <div class="dialogError">{props.error}</div>}
      {props.actions && <div class="dialogActions">{props.actions}</div>}
    </div>
  );
}
